// Keep in sync with bft-dashboards/src/common/analytics/cookie.ts.
const SHARED_DOMAINS = ['bestfoodtrucks.com', 'bft.com']

// Undefined on hosts that aren't ours (vercel previews, localhost) — an
// unrelated domain attribute makes the browser drop the cookie silently.
export function sharedCookieDomain(
  hostname = typeof window === 'undefined' ? '' : window.location.hostname
): string | undefined {
  const match = SHARED_DOMAINS.find(
    (domain) => hostname === domain || hostname.endsWith(`.${domain}`)
  )
  return match && `.${match}`
}

export function getCookie(name: string): string | undefined {
  if (typeof document === 'undefined') return undefined

  const value = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${name}=`))
    ?.slice(name.length + 1)

  if (value === undefined) return undefined
  try {
    return decodeURIComponent(value)
  } catch {
    return value
  }
}

const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365

export function setSharedCookie(name: string, value: string) {
  if (typeof document === 'undefined') return

  const domain = sharedCookieDomain()
  const parts = [
    `${name}=${encodeURIComponent(value)}`,
    'path=/',
    `max-age=${ONE_YEAR_SECONDS}`,
    'SameSite=Lax'
  ]
  if (domain) parts.push(`domain=${domain}`)
  if (window.location.protocol === 'https:') parts.push('Secure')

  document.cookie = parts.join('; ')
}
